export default "__VITE_ASSET__DSC961bU__"